import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDo9Viz7iQlAgOUPk_iGQtKU8DXtIJ85QM',
  authDomain: 'cheriecoiffer-react.firebaseapp.com',
  projectId: 'cheriecoiffer-react',
  storageBucket: 'cheriecoiffer-react.firebasestorage.app',
  messagingSenderId: '764192595576',
  appId: '1:764192595576:web:d0af15cfe9b99277b3578d',
  measurementId: 'G-7R772TCLQM',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, auth, firebaseConfig };
